<template>
  <header>
    ポイント購入
    <div class="h-left">
      <a @click="$router.go(-1), setFooter(false)"
        ><img src="~@/assets/images/icon02.svg"
      /></a>
    </div>
  </header>
  <div id="wrap">
    <ul class="txt-area">
      <li>
        <a href="#"><img src="~@/assets/images/p-banner-98.png" /></a>
      </li>
      <li>
        <a href="#"><img src="~@/assets/images/p-banner-208.png" /></a>
      </li>
      <li>
        <a href="#"><img src="~@/assets/images/p-banner-502.png" /></a>
      </li>
      <li>
        <a href="#"><img src="~@/assets/images/p-banner-1050.png" /></a>
      </li>
      <li>
        <a href="#"><img src="~@/assets/images/p-banner-2100.png" /></a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from "vuex"
export default {
  methods: {
    ...mapActions({
      setFooter: "layout/setFooter",
    }),
  },
};
</script>